
import { useEffect } from "react";
import { useDrag } from "react-dnd";
import { TableRow } from "@mui/material";
import { getEmptyImage } from 'react-dnd-html5-backend';
import { useTableUI } from "../contexts/TableUIContext";

const DraggableRow = ({ row, children, ...props }) => {
    const { selectedRows } = useTableUI();

    const dragItems = selectedRows;

    const [, dragRef, preview] = useDrag(() => ({
        type: "ROW",
        item: { type: "ROW", items: dragItems },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }), [selectedRows, row]);

    useEffect(() => {
        preview(getEmptyImage(), { captureDraggingState: true });
    }, [preview]);

    return (
        <TableRow
            ref={dragRef}
            {...props}
        >
            {children}
        </TableRow>
    );
};

export default DraggableRow;
